import { CollaborationTemplateDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import React from 'react';
import NewRequestAutosave from './NewRequest/NewRequestSubmission';

interface SubmitRequestProps {
	template: CollaborationTemplateDto | undefined;
}

const SubmitRequest = ({ template }: SubmitRequestProps) => {
  return (
    <div className="flex items-center mb-6">
      <h2 className="text-2xl font-bold tracking-tight text-gray-800">3. Submit your request</h2>
      <span className="flex-1 block h-px mx-2 bg-gray-300"></span>
      <NewRequestAutosave
        template={template}
        showAutosave={false}
        testSelectorPrefix="request-footer"
      />
    </div>
  );
};

export { SubmitRequest as default };
